(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cancel-order-form"] && !Shopify.designMode) return;
  try {
    class CancelOrderForm extends HTMLElement {
    #controller = null;
    #statusTimeout = null;

    connectedCallback() {
      this.form = this.querySelector('[ref="form"]');
      this.submit = this.querySelector('[ref="submit"]');
      this.status = this.querySelector('[ref="status"]');
      this.successMessage = this.dataset.successMessage;
      this.errorMessage = this.dataset.errorMessage;

      this.form?.addEventListener('submit', this.#handleSubmit);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.#handleSubmit);
      this.#controller?.abort();
      clearTimeout(this.#statusTimeout);
    }

    #handleSubmit = async (event) => {
      event.preventDefault();

      if (!this.form.reportValidity()) return;

      this.#controller?.abort();
      this.#controller = new AbortController();

      this.#setLoading(true);
      this.#clearStatus();

      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          headers: { Accept: 'application/json' },
          signal: this.#controller.signal,
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          const message = data?.errors?.map((error) => error.message).join(', ');
          throw new Error(message || this.errorMessage);
        }

        this.form.reset();
        this.#showStatus('success', this.successMessage);

        this.dispatchEvent(new CustomEvent('cancel-order:submitted', { detail: data, bubbles: true }));
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error('Cancel order form error:', error);
        this.#showStatus('error', error.message || this.errorMessage);
      } finally {
        this.#setLoading(false);
      }
    };

    #setLoading(isLoading) {
      this.toggleAttribute('loading', isLoading);
      if (this.submit) this.submit.disabled = isLoading;
    }

    #showStatus(state, message) {
      if (!this.status) return;
      clearTimeout(this.#statusTimeout);
      this.status.dataset.state = state;
      this.status.textContent = message;
      this.status.hidden = false;
      this.#statusTimeout = setTimeout(() => this.#clearStatus(), 5000);
    }

    #clearStatus() {
      if (!this.status) return;
      clearTimeout(this.#statusTimeout);
      this.status.hidden = true;
      this.status.textContent = '';
      delete this.status.dataset.state;
    }
  }

  if (!customElements.get('cancel-order-form')) {
    customElements.define('cancel-order-form', CancelOrderForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["checkbox"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || event.repeat) return;
    if (!event.target.hasAttribute('data-checkbox-enter')) return;

    event.preventDefault();
    event.target.checked = !event.target.checked;
    event.target.dispatchEvent(new Event('change', { bubbles: true }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["grid-density-controls"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const btn = e.target.closest('.column-option');
    if (!btn) return;

    const wrapper = btn.closest('.column-options-wrapper');
    const radio = wrapper.querySelector(`.column-options__radio[value="${btn.dataset.value}"]`);
    if (!radio || radio.checked) return;

    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));

    wrapper.querySelectorAll('.column-option').forEach((b) => {
      const isActive = b.dataset.value === btn.dataset.value;
      b.classList.toggle('is-active', isActive);
      b.setAttribute('aria-pressed', String(isActive));
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-filters"] && !Shopify.designMode) return;
  try {
    /* Quick filters sit outside the section the filter system re-renders, so they
     can't just be inputs in the facets form. They reach it the way the remove
     pills do instead: build the URL the filter should lead to and hand it over. */
  const quickFilters = document.querySelector('[data-quick-filters]');

  if (quickFilters) {
    const quickFilterInputs = quickFilters.querySelectorAll('input[type="checkbox"]');
    /* Kept across re-renders: the element is matched on its id when the section
       is morphed, so the same node is reused rather than replaced. */
    const facetsForm = document.querySelector('facets-form-component');

    const applyQuickFilter = (input) => {
      const url = new URL(window.location.href);
      const applied = url.searchParams.getAll(input.name);
      /* Shopify carries several values for one filter as a repeated parameter,
         so a value is added or dropped from the list under its own name. */
      const next = input.checked
        ? [...new Set([...applied, input.value])]
        : applied.filter((value) => value !== input.value);

      url.searchParams.delete(input.name);
      for (const value of next) url.searchParams.append(input.name, value);
      url.searchParams.delete('page');

      if (typeof facetsForm?.updateFiltersByURL === 'function') {
        facetsForm.updateFiltersByURL(url.toString());
      } else {
        // No filters on the collection, so there is no form to render through.
        window.location.assign(url.toString());
      }
    };

    quickFilters.addEventListener('change', (event) => {
      if (event.target instanceof HTMLInputElement) applyQuickFilter(event.target);
    });

    /* The URL is the only state these inputs can trust: a value can just as well
       be dropped from the drawer or a remove pill, and neither touches them. */
    document.addEventListener('filter:update', () => {
      const { searchParams } = new URL(window.location.href);

      for (const input of quickFilterInputs) {
        input.checked = searchParams.getAll(input.name).includes(input.value);
      }
    });

    /* Whether a value is still worth offering depends on the results, which only
       the server counts, so it is mirrored from the value's twin in the drawer —
       re-rendered with a fresh `disabled` on every filter change. Watching for
       that is what makes the timing work, too: `filter:update` fires before the
       new markup has even been asked for, when the drawer still reads as it did
       before the change. */
    if (facetsForm) {
      const mirrorAvailability = () => {
        const twins = new Map();

        for (const twin of facetsForm.querySelectorAll('input[name][value]')) {
          twins.set(`${twin.name}\n${twin.value}`, twin.disabled);
        }

        for (const input of quickFilterInputs) {
          const disabled = twins.get(`${input.name}\n${input.value}`);
          /* Left as it is when the drawer holds no twin to read, rather than
             guessing at a state the filter may never be able to leave. */
          if (disabled !== undefined) input.disabled = disabled;
        }
      };

      let mirrorTimer;
      // A morph touches every input in turn, so the reads wait for it to finish.
      new MutationObserver(() => {
        clearTimeout(mirrorTimer);
        mirrorTimer = setTimeout(mirrorAvailability, 0);
      }).observe(facetsForm, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['disabled'],
      });
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["retailer-finder-contact-form"] && !Shopify.designMode) return;
  try {
    class RetailerFinderContactForm extends HTMLElement {
    #controller = null;
    #statusTimeout = null;

    connectedCallback() {
      this.form = this.querySelector('[ref="form"]');
      this.submit = this.querySelector('[ref="submit"]');
      this.status = this.querySelector('[ref="status"]');
      this.successMessage = this.dataset.successMessage;
      this.errorMessage = this.dataset.errorMessage;

      this.form?.addEventListener('submit', this.#handleSubmit);
      this.form?.addEventListener('input', this.#handleInput);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.#handleSubmit);
      this.form?.removeEventListener('input', this.#handleInput);
      this.#controller?.abort();
      clearTimeout(this.#statusTimeout);
    }

    #handleInput = (event) => {
      const field = event.target;
      if (field instanceof HTMLInputElement) this.#clearFieldError(field);
    };

    #validate() {
      let firstInvalid = null;

      this.form.querySelectorAll('input[required]').forEach((field) => {
        if (field.checkValidity()) {
          this.#clearFieldError(field);
        } else {
          this.#showFieldError(field);
          if (!firstInvalid) firstInvalid = field;
        }
      });

      if (firstInvalid) firstInvalid.focus();
      return !firstInvalid;
    }

    #errorFor(field) {
      const id = field.getAttribute('aria-describedby');
      return id ? this.querySelector(`#${CSS.escape(id)}`) : null;
    }

    #showFieldError(field) {
      field.setAttribute('aria-invalid', 'true');
      const error = this.#errorFor(field);
      if (error) {
        error.textContent = field.dataset.errorMessage || '';
        error.hidden = false;
      }
    }

    #clearFieldError(field) {
      field.removeAttribute('aria-invalid');
      const error = this.#errorFor(field);
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }
    }

    #handleSubmit = async (event) => {
      event.preventDefault();

      if (!this.#validate()) return;

      this.#controller?.abort();
      this.#controller = new AbortController();

      this.#setLoading(true);
      this.#clearStatus();

      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          headers: { Accept: 'application/json' },
          signal: this.#controller.signal,
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          const message = data?.errors?.map((error) => error.message).join(', ');
          throw new Error(message || this.errorMessage);
        }

        this.form.reset();
        this.#showStatus('success', this.successMessage);

        this.dispatchEvent(new CustomEvent('retailer-finder:submitted', { detail: data, bubbles: true }));
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error('Retailer finder contact form error:', error);
        this.#showStatus('error', error.message || this.errorMessage);
      } finally {
        this.#setLoading(false);
      }
    };

    #setLoading(isLoading) {
      this.toggleAttribute('loading', isLoading);
      if (this.submit) this.submit.disabled = isLoading;
    }

    #showStatus(state, message) {
      if (!this.status) return;
      clearTimeout(this.#statusTimeout);
      this.status.dataset.state = state;
      this.status.textContent = message;
      this.status.hidden = false;
      if (state === 'success') {
        this.#statusTimeout = setTimeout(() => this.#clearStatus(), 8000);
      }
    }

    #clearStatus() {
      if (!this.status) return;
      clearTimeout(this.#statusTimeout);
      this.status.hidden = true;
      this.status.textContent = '';
      delete this.status.dataset.state;
    }
  }

  if (!customElements.get('retailer-finder-contact-form')) {
    customElements.define('retailer-finder-contact-form', RetailerFinderContactForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rolling-usps"] && !Shopify.designMode) return;
  try {
    class RollingUsps extends HTMLElement {
    connectedCallback() {
      if (!this.ready) this.init();
      if (!this.ready) return;
      if (!this.observer) {
        this.observer = new IntersectionObserver((entries) => {
          this.onVisibilityChange(entries[0].isIntersecting);
        });
      }
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stopLoop();
      if (this.observer) this.observer.unobserve(this);
    }

    init() {
      this.ready = false;
      this.count = this.querySelectorAll('.rolling-usps__line').length;
      // Single message (or fewer) needs no rotation.
      if (this.count < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.track = this.querySelector('.rolling-usps__track');
      this.progress = this.querySelector('.rolling-usps__ring-progress');
      this.button = this.querySelector('.rolling-usps__timer');
      this.duration = parseFloat(this.dataset.duration) || 6;
      this.current = 0;
      this.elapsed = 0;
      this.paused = false;

      if (this.button) {
        this.button.addEventListener('click', () => this.toggle());
      }
      this.move();
      this.ready = true;
    }

    onVisibilityChange(isVisible) {
      if (isVisible && !this.paused) this.startLoop();
      else this.stopLoop();
    }

    startLoop() {
      if (this.raf) return;
      let last = null;
      const loop = (now) => {
        this.raf = requestAnimationFrame(loop);
        if (last === null) {
          last = now;
          return;
        }
        this.elapsed += (now - last) / 1000;
        last = now;
        if (this.elapsed >= this.duration) {
          this.elapsed = 0;
          this.current = (this.current + 1) % this.count;
          this.move();
        }
        this.drawRing();
      };
      this.raf = requestAnimationFrame(loop);
    }

    stopLoop() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = null;
    }

    toggle() {
      this.paused = !this.paused;
      if (this.paused) {
        this.stopLoop();
        this.classList.add('rolling-usps--paused');
        if (this.button) {
          this.button.setAttribute('aria-label', this.dataset.playLabel || 'Play');
        }
      } else {
        this.classList.remove('rolling-usps--paused');
        if (this.button) {
          this.button.setAttribute('aria-label', this.dataset.pauseLabel || 'Pause');
        }
        this.startLoop();
      }
    }

    move() {
      if (!this.track) return;
      this.track.style.transform =
        'translateY(calc(-1 * ' + this.current + ' * (var(--rolling-usps-line-height) + var(--rolling-usps-gap))))';
    }

    drawRing() {
      if (!this.progress) return;
      const progress = Math.min(this.elapsed / this.duration, 1);
      this.progress.style.strokeDashoffset = String(100 - progress * 100);
    }
  }

  if (!customElements.get('rolling-usps')) {
    customElements.define('rolling-usps', RollingUsps);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-predictive-drawer"] && !Shopify.designMode) return;
  try {
    class SearchDrawerButtonUpdater {
    constructor() {
      const panel = document.querySelector('.search-drawer-panel');
      if (!panel) return;

      const button = panel.querySelector('.search-drawer-panel__show-results-button');
      const results = panel.querySelector('.search-drawer-panel__results');
      if (!button || !results) return;

      this.button = button;
      this.results = results;
      this.defaultText = button.dataset.defaultText || 'Show results';
      this.countTemplate = button.dataset.countText || 'Show results (__COUNT__)';

      const observer = new MutationObserver(() => this.update());
      observer.observe(results, { childList: true, subtree: true });
      this.update();
    }

    update() {
      const hasResults = this.results.querySelector('[data-search-results]');
      const noResults = this.results.querySelector('.predictive-search-results__no-results');

      if (hasResults && !noResults) {
        const products = this.results.querySelectorAll('.predictive-search-results__card--product');
        const pages = this.results.querySelectorAll('.predictive-search-results__page-row');

        if (products.length > 0) {
          this.button.textContent = this.countTemplate.replace('__COUNT__', String(products.length));
          this.button.disabled = false;
        } else if (pages.length > 0) {
          this.button.textContent = this.defaultText;
          this.button.disabled = false;
        } else {
          this.button.textContent = this.defaultText;
          this.button.disabled = true;
        }
      } else {
        this.button.textContent = this.defaultText;
        this.button.disabled = true;
      }
    }
  }

  new SearchDrawerButtonUpdater();

  const drawerForm = document.getElementById('search-drawer-form');
  if (drawerForm) {
    drawerForm.addEventListener('submit', () => {
      const results = drawerForm.querySelector('.search-drawer-panel__results');
      const typeInput = drawerForm.querySelector('input[name="type"]');
      if (!results || !typeInput) return;

      const products = results.querySelectorAll('.predictive-search-results__card--product');
      if (products.length === 0) {
        const linkResults = results.querySelectorAll('.predictive-search-results__page-row');
        if (linkResults.length > 0) {
          typeInput.value = 'page,article';
        }
      }
    });
  }

  const drawerPanel = document.querySelector('.search-drawer-panel');
  if (drawerPanel) {
    const searchInput = drawerPanel.querySelector('.search-drawer-panel__input');
    const overlayPanel = drawerPanel.closest('.drawer-overlay__panel');
    if (searchInput && overlayPanel) {
      new MutationObserver(() => {
        // Only autofocus while the drawer is actually OPEN. The panel keeps
        // `display != none` throughout its ~300ms leave transition, so without
        // this guard the observer re-grabs the input mid-close and fights the
        // focus restore back to the search toggle (see $store.overlay.hide).
        const overlayStore = window.Alpine && window.Alpine.store('overlay');
        const isOpen = overlayStore ? overlayStore.open === 'search' : getComputedStyle(overlayPanel).display !== 'none';
        if (isOpen) {
          setTimeout(() => {
            if (window.Alpine && window.Alpine.store('overlay').open !== 'search') return;
            searchInput.focus({ preventScroll: true });
          }, 60);
        }
      }).observe(overlayPanel, { attributes: true, attributeFilter: ['style'] });
    }

    drawerPanel.addEventListener('click', (e) => {
      const pill = e.target.closest('[data-search-prompt]');
      if (!pill) return;

      const term = pill.dataset.searchPrompt;
      const input = drawerPanel.querySelector('.search-drawer-panel__input');
      if (!input) return;

      input.focus();
      input.value = '';
      document.execCommand('insertText', false, term);

      const reset = drawerPanel.querySelector('.search-drawer-panel__clear-button');
      if (reset) reset.hidden = false;
    });
  }
  } catch(e) { console.error(e); }
})();

})();
